import { Routes } from '@angular/router';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';

export const signatureRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'sign',
        loadComponent: () => import('./signature.component').then(m => m.SignatureComponent),
        children: [
          {
            path: ':uuid',
            loadComponent: () => import('./signature-document/signature-document.component').then(m => m.SignatureDocumentComponent),
          },
        ],
      },
    ],
  },
];
